"use client"

import HeaderGroupSkeleton from "@/components/header/header-group-skeleton"
import { SiteId } from "@/sites/config"

interface HeaderSkeletonProps {
  siteId?: SiteId
}

const HeaderSkeleton = ({ siteId = "tamdamedia.eu" }: HeaderSkeletonProps) => {
  if (siteId !== "tamdamedia.eu") {
    return <HeaderGroupSkeleton />
  }
  return (
    <div className="w-full">
      {/* Banner Skeleton */}
      <div className="w-full bg-gray-200 animate-pulse">
        <div className="max-w-[343px] sm:max-w-[1128px] mx-auto px-4 sm:px-0">
          <div className="h-[150px] sm:h-[250px] bg-gray-300 rounded" />
        </div>
      </div>

      {/* Header Detail Skeleton */}
      <div className="w-full bg-white">
        <div className="max-w-[1128px] mx-auto">
          {/* Desktop Layout */}
          <div className="hidden sm:flex items-start justify-between py-6">
            {/* Left: Date and Currency */}
            <div className="flex flex-col gap-7 w-[25%]">
              <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" />
              <div className="h-4 w-28 bg-gray-200 rounded animate-pulse" />
            </div>

            {/* Center: Logo and Slogan */}
            <div className="flex flex-col items-center gap-4 w-[45.84%]">
              <div className="h-10 w-48 bg-gray-200 rounded animate-pulse" />
              <div className="h-4 w-64 bg-gray-200 rounded animate-pulse" />
            </div>

            {/* Right: Contact and Search */}
            <div className="flex flex-col gap-7 w-[29.16%] items-end">
              <div className="w-[240px] flex flex-col gap-7">
                <div className="flex items-center gap-6 justify-between">
                  <div className="h-5 w-32 bg-gray-200 rounded animate-pulse" />
                  <div className="flex gap-1">
                    <div className="h-6 w-6 bg-gray-200 rounded-full animate-pulse" />
                    <div className="h-6 w-6 bg-gray-200 rounded-full animate-pulse" />
                  </div>
                </div>
                <div className="h-9 w-[180px] bg-gray-200 rounded animate-pulse" />
              </div>
            </div>
          </div>

          {/* Mobile Layout */}
          <div className="sm:hidden flex items-center justify-center py-5">
            <div className="h-9 w-48 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>
      </div>

      {/* Header List Skeleton */}
      <div className="w-full bg-gray-200 animate-pulse">
        <div className="max-w-[1128px] mx-auto">
          <div className="h-12 sm:h-[3rem] flex items-center gap-4 px-4">
            <div className="h-4 w-20 bg-gray-300 rounded animate-pulse" />
            <div className="h-4 w-16 bg-gray-300 rounded animate-pulse" />
            <div className="h-4 w-24 bg-gray-300 rounded animate-pulse" />
            <div className="h-4 w-16 bg-gray-300 rounded animate-pulse" />
            <div className="h-4 w-20 bg-gray-300 rounded animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderSkeleton
